import {
    DASHBOARD_CHART_DATA_UPDATE,
    DASHBOARD_CHART_IS_LOADING,
    DASHBOARD_DATA_UPDATE,
    DASHBOARD_IS_LOADING,
    DASHBOARD_PERIOD_NAME_UPDATE,
    DASHBOARD_PERIOD_UPDATE,
    DASHBOARD_RANGE_UPDATE,
    DASHBOARD_TABLE_DATA_LOADING,
    DASHBOARD_TABLE_DATA_UPDATE,
    DASHBOARD_CHART_CUSTOMIZER_DATA_UPDATE,
    DASHBOARD_CUSTOMIZER_UPDATE,
    DASHBOARD_HAS_ACTIVE_USER_UPDATE,
    DASHBOARD_PARTS_SELECTED_UPDATE,
    DASHBOARD_DATA_LOADED
} from "../actions/detailsPageActions";
import moment from "moment/moment";

export const initialState = {
    isLoading: false,
    data: {
        customerCompany: {},
        locationCompany: {},
        orderParts: []
    },
    range: {
        end: moment().endOf('day'),
        start: moment().startOf('month')
    },
    period: false,
    periodName: null,
    chartIsLoading: false,
    chartData: {},
    chartCustomizerData: {},
    tableDataLoading: false,
    tableData: {
        generalSummaryPerPart: {
            header: [],
            rows: [],
            partNumberNameArray: []
        }
    },
    customizations: [],
    selectedParts: [],
    hasActiveUser: false,
    dashboardDataLoaded: false
}
export default function detailsPageReducer(state = initialState, action) {
    switch (action.type) {
        case DASHBOARD_IS_LOADING:
            return {
                ...state,
                isLoading: action.payload
            }
        case DASHBOARD_DATA_LOADED:
            return {
                ...state,
                dashboardDataLoaded: action.payload
            }
        case DASHBOARD_DATA_UPDATE:
            return {
                ...state,
                data: action.payload
            }
        case DASHBOARD_PERIOD_UPDATE:
            return {
                ...state,
                period: action.payload
            }
        case DASHBOARD_RANGE_UPDATE:
            return {
                ...state,
                range: action.payload
            }
        case DASHBOARD_PERIOD_NAME_UPDATE:
            return {
                ...state,
                periodName: action.payload
            }
        case DASHBOARD_CHART_IS_LOADING:
            return {
                ...state,
                chartIsLoading: action.payload
            }
        case DASHBOARD_CHART_DATA_UPDATE:
            return {
                ...state,
                chartData: action.payload
            }
        case DASHBOARD_TABLE_DATA_LOADING:
            return {
                ...state,
                tableDataLoading: action.payload
            }
        case DASHBOARD_TABLE_DATA_UPDATE:
            return {
                ...state,
                tableData: action.payload
            }
        case DASHBOARD_CHART_CUSTOMIZER_DATA_UPDATE:
            return {
                ...state,
                chartCustomizerData: action.payload
            }
        case DASHBOARD_CUSTOMIZER_UPDATE:
            return {
                ...state,
                customizations: action.payload
            }
        case DASHBOARD_HAS_ACTIVE_USER_UPDATE:
            return {
                ...state,
                hasActiveUser: action.payload
            }
        case DASHBOARD_PARTS_SELECTED_UPDATE:
            return {
                ...state,
                selectedParts: action.payload
            }
        case 'CUSTOMIZATION_FILTER_UPDATE':
            return {
                ...state,
                customizations: state.customizations.map(item =>
                    item.key === action.payload.key.toString()
                        ? { ...item, ...action.payload.filterData }
                        : item
                )
            };
        default:
            return state;
    }
}
